import { faBars } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { IconButton } from "@mui/material"
import { Box } from "@mui/system"
import React from "react"
import { HEADER_PHONE_HEIGHT_IN_REM } from "ui/model"
import { setMenuExpansion } from "ui/tools/menu"
import { Logo } from "../Logo"

export const HeaderPhone = () => (
  <Box
    sx={{
      width: "100%",
      height: HEADER_PHONE_HEIGHT_IN_REM,
      minHeight: HEADER_PHONE_HEIGHT_IN_REM,
      maxHeight: HEADER_PHONE_HEIGHT_IN_REM,
      padding: "0",
      pl: "1rem",
      pr: "1rem",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
      borderBottom: theme => theme.palette.border,
      backgroundColor: theme => theme.palette.background.paper
    }}>
    <Logo sx={{ width: "7rem", height: "3rem", backgroundPosition: "left" }} />
    <IconButton aria-label="delete" onClick={() => setMenuExpansion(true)}>
      <FontAwesomeIcon className="header-create-campaign" icon={faBars} size="1x" />
    </IconButton>
  </Box>
)
